const appName = import.meta.env.VITE_APP_NAME ?? 'Git Digest'

export function formatPageTitle(title: string) {
  if (!title || title === appName || title.endsWith(` - ${appName}`)) {
    return title || appName
  }

  return `${title} - ${appName}`
}
